import React from 'react';
import PropTypes from 'prop-types';
import { getMarkerIconSize } from '@utils/icon-utils';

const MarkerIcon = ({ icon }) => {
  if (!icon?.url) {
    return null;
  }
  const { width, height } = getMarkerIconSize(icon);
  return (
    <img alt="" draggable={false} src={icon.url} style={{ display: 'block', height, width }} />
  );
};

MarkerIcon.propTypes = {
  icon: PropTypes.object
};

export default MarkerIcon;
